@use "Styles/mixins";
@use "Styles/includes/variables";

:host {
    box-sizing: border-box;
    display: inline-flex;
}

.vm-label {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    padding: 2px 8px;
    border-radius: 9999px;
    font-family: variables.$fontQuaternary;
    font-weight: 700;
    font-size: mixins.get-font-size(text-xs);
    line-height: mixins.get-line-height(text-xs);
    text-transform: uppercase;

    background-color: mixins.get-color(bg, transparent, tertiary);
    color: mixins.get-color(text, primary);
}

:host([variant="primary"]) .vm-label {
    text-transform: none;

    background-color: mixins.get-color(background, bg-brand-secondary);
    color: mixins.get-color(text, text-brand-secondary-hover);
}
